import { IDOMManager } from './interfaces';

export class GTMManager {
  SCRIPT_ID = 'SCRIPT_ID';

  IFRAME_ID = 'IFRAME_ID';

  private enabled = false;

  constructor(
    private domManager: IDOMManager,
    private gtmId: string | undefined,
    private autoInstall = true,
  ) {
    if (this.autoInstall !== false) {
      this.enable();
    }
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  handleScriptCreation(gtmId: string): void {
    const script = this.domManager.createScript(this.SCRIPT_ID);
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    this.domManager.appendToHead(script);
  }

  handleIFrameCreation(gtmId: string): void {
    const iframe = this.domManager.createNoScript(this.IFRAME_ID);
    iframe.textContent = `<iframe src='https://www.googletagmanager.com/ns.html?id=${gtmId}' height='0' width='0' style='display:none;visibility:hidden' />`;
    this.domManager.appendToBody(iframe);
  }

  enable(): void {
    if (!this.gtmId) return;

    this.enabled = true;
    this.handleScriptCreation(this.gtmId);
    this.handleIFrameCreation(this.gtmId);
  }

  disable(): void {
    this.enabled = false;
    this.domManager.removeFromHeadById(this.SCRIPT_ID);
    this.domManager.removeFromBodyById(this.IFRAME_ID);
  }

  trackEvent(event = {}): void {
    if (!this.enabled) return;

    this.domManager.appendToDatalayer(event);
  }
}

export default GTMManager;
